import { createFileRoute, redirect } from '@tanstack/react-router';
import { SIGN_IN, PROTECTED_DASHBOARD } from '@/lib/constants/routes';
import { queryClient } from '@/api/common/client';
import { ensureAuthData } from '@/api/auth/auth-query';
import { advisorQueryKeys } from '@/api/advisor/query-keys';
import { AdvisorLayout } from '@/pages/studio/advisor-layout';
import { Studio } from '@/pages/studio';

/**
 * Pannello commercialista: route top-level FUORI da /protected. Richiede
 * solo autenticazione + isAdvisor, nessun tenant selezionato. Il contesto
 * tenant si attiva solo aprendo un cliente dal pannello.
 */
export const Route = createFileRoute('/studio')({
  beforeLoad: async () => {
    const data = await ensureAuthData(queryClient);
    if (!data.authenticated) {
      throw redirect({ to: SIGN_IN });
    }

    const status = await queryClient
      .ensureQueryData(advisorQueryKeys.status())
      .catch(() => null);
    if (!status?.isAdvisor) {
      throw redirect({ to: PROTECTED_DASHBOARD });
    }
  },
  component: () => (
    <AdvisorLayout>
      <Studio />
    </AdvisorLayout>
  ),
});
